<template>
    <div class="grid grid-cols-6 gap-3 bg-lightGray">
        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/sale.png" alt="" class="h-8">
                </div>
                <div class="font-bold">
                    {{ $t('sale.title') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.totalSale, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>

        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/cash.png" alt="" class="h-8">
                </div>
                <div class="font-bold">
                    {{ $t('statistics.categories.cash') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.cash, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>

        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/bankCard.png" alt="" class="h-8">
                </div>
                <div class="font-bold">
                    {{ $t('statistics.categories.bankCard') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.bankCard, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>

        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/moneyTransfer.png" alt="" class="h-8">
                </div>
                <div class="font-bold">
                    {{ $t('statistics.categories.moneyTransfer') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.moneyTransfer, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>

        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/forDebt.png" alt="" class="h-8 bg-red-200 rounded py-1 px-2">
                </div>
                <div class="font-bold">
                    {{ $t('statistics.categories.debt') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.debt, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>

        <div class="col-span-6 sm:col-span-3 md:col-span-2 xl:col-span-1 bg-white rounded shadow">
            <div class="flex justify-center items-center mt-3 gap-2">
                <div>
                    <img src="/images/income.png" alt="" class="h-8">
                </div>
                <div class="font-bold">
                    {{ $t('statistics.categories.profit') }}
                </div>
            </div>
            <div v-if="currentCurrency" class="font-bold text-center mt-3 pb-3">
                {{ showCurrencyById(currentCurrency.id, calculateAmountByBaseCurrency(getCompanyPayTypeStatistics.income, baseCurrencyShortName, currentCurrency.shortName)) }}
            </div>
        </div>
    </div>
</template>

<script>
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import {mapActions, mapGetters} from "vuex";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "TodaySaleStat",
    mixins: [dateFormattingMixin, currencyFormatMixin, currencyRateMixin],
    props: {
        period: {
            type: String,
        },
        currencyShortName: {
            type: String,
            default: 'UZS'
        },
    },
    data() {
        return {
            date: null,
            month: 0,
            search: {
                startDate: '',
                endDate: '',
                employeeId: null,
                isDaily: false,
                isMonthly: false,
            },
            optionsMonth: [
                {value: {start: '01-01', end: '01-31'}, text: this.$t('statistics.month.Jan')},
                {value: {start: '02-01', end: '02-28'}, text: this.$t('statistics.month.Feb')},
                {value: {start: '03-01', end: '03-31'}, text: this.$t('statistics.month.Mar')},
                {value: {start: '04-01', end: '04-30'}, text: this.$t('statistics.month.Apr')},
                {value: {start: '05-01', end: '05-31'}, text: this.$t('statistics.month.May')},
                {value: {start: '06-01', end: '06-30'}, text: this.$t('statistics.month.Jun')},
                {value: {start: '07-01', end: '07-31'}, text: this.$t('statistics.month.Jul')},
                {value: {start: '08-01', end: '08-31'}, text: this.$t('statistics.month.Aug')},
                {value: {start: '09-01', end: '09-30'}, text: this.$t('statistics.month.Sep')},
                {value: {start: '10-01', end: '10-31'}, text: this.$t('statistics.month.Oct')},
                {value: {start: '11-01', end: '11-30'}, text: this.$t('statistics.month.Nov')},
                {value: {start: '12-01', end: '12-31'}, text: this.$t('statistics.month.Dec')},
            ],

        }
    },
    computed: {
        ...mapGetters(['getCompanyPayTypeStatistics', 'getUserCompany']),
        currentCurrency() {
            return this.getCurrencyByShortName(this.currencyShortName)
        }
    },
    methods: {
        ...mapActions(['fetchCompanyPayTypeStatistics', 'fetchUser']),
        getFullDate() {
            this.date = new Date().getDate()
            this.month = new Date().getMonth()
            let days = [this.$t('statistics.weekday.sun'), this.$t('statistics.weekday.mon'), this.$t('statistics.weekday.tue'), this.$t('statistics.weekday.wed'), this.$t('statistics.weekday.thu'), this.$t('statistics.weekday.fri'), this.$t('statistics.weekday.sat')];
            let d = new Date();
            this.weekday = days[d.getDay()]
        },
    },
}
</script>

<style scoped>

.card-dark {
    border: 1px solid #bababa;
}

</style>